import santi from "../assets/img/testimonials/santi.jpeg";
import christian from "../assets/img/testimonials/christian.jpeg";
import ruma from "../assets/img/testimonials/ruma.jpeg";
import cande from "../assets/img/testimonials/cande.jpeg";
import lu from "../assets/img/testimonials/lu.jpeg";
import gaby from "../assets/img/testimonials/gaby.jpeg";

export const testimonials = [
  {
    image: santi,
    name: "Santiago Tapia",
    company: "CEO, Curador",
    commentKey: "testimonial.santiago.comment",
  },
  {
    image: christian,
    name: "Christian Pasquel",
    company: "CTO, Curador / CEO, Portal Labs",
    commentKey: "testimonial.christian.comment",
  },
  {
    image: ruma,
    name: "Jorge Matute",
    company: "Frontend Developer, Curador",
    commentKey: "testimonial.jorge.comment",
  },
  {
    image: cande,
    name: "Cande Rabec",
    company: "Software Quality Assurance Tester, Curador",
    commentKey: "testimonial.cande.comment",
  },
  {
    image: lu,
    name: "Lucero Gonzales",
    company: "Frontend Developer, Laboratoria",
    commentKey: "testimonial.lucero.comment",
  },
  {
    image: gaby,
    name: "Gabriela Díaz",
    company: "Frontend Developer, Laboratoria",
    commentKey: "testimonial.gabriela.comment",
  },
];
